<script setup>
import WootReports from './components/WootReports.vue';
import LabelExtraCharts from './components/LabelExtraCharts.vue';
import { ref } from 'vue';
import V4Button from 'dashboard/components-next/button/Button.vue';

const pageRef = ref(null);

function loadScript(src) {
  return new Promise((resolve, reject) => {
    const existing = document.querySelector(`script[src="${src}"]`);
    if (existing) {
      existing.addEventListener('load', () => resolve());
      existing.addEventListener('error', e => reject(e));
      if (existing.readyState === 'complete') resolve();
      return;
    }
    const s = document.createElement('script');
    s.src = src;
    s.async = true;
    s.onload = () => resolve();
    s.onerror = e => reject(e);
    document.body.appendChild(s);
  });
}

async function onDownloadPdf() {
  await loadScript('https://cdn.jsdelivr.net/npm/jspdf@2.5.1/dist/jspdf.umd.min.js');
  await loadScript('https://cdn.jsdelivr.net/npm/html2canvas@1.4.1/dist/html2canvas.min.js');
  const { jsPDF } = window.jspdf || {};
  const html2canvas = window.html2canvas;
  if (!jsPDF || !html2canvas) return;

  const node = pageRef.value;
  const canvas = await html2canvas(node, { scale: 2, useCORS: true, backgroundColor: '#ffffff' });
  const doc = new jsPDF('p', 'pt', 'a4');
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();
  const ratio = Math.min(pageWidth / canvas.width, pageHeight / canvas.height);
  const imgWidth = canvas.width * ratio;
  const imgHeight = canvas.height * ratio;
  const x = (pageWidth - imgWidth) / 2;
  const y = 20;
  doc.addImage(canvas.toDataURL('image/png'), 'PNG', x, y, imgWidth, imgHeight, undefined, 'FAST');
  doc.save('label-report.pdf');
}
</script>

<template>
  <div ref="pageRef">
    <WootReports
      key="label-reports"
      type="label"
      getter-key="labels/getLabels"
      action-key="labels/get"
      :download-button-label="$t('LABEL_REPORTS.DOWNLOAD_LABEL_REPORTS')"
      :report-title="$t('LABEL_REPORTS.HEADER')"
    >
      <template #actions>
        <V4Button
          class="ms-2"
          :label="$t('LABEL_REPORTS_ACTIONS.DOWNLOAD_LABEL_PDF')"
          icon="i-ph-file-pdf"
          size="sm"
          @click="onDownloadPdf"
        />
      </template>
      <template #extra="slotProps">
        <LabelExtraCharts v-bind="slotProps" />
      </template>
    </WootReports>
  </div>
</template>
